module.exports = __webpack_public_path__ + "media/app/assets/navIcons/arena-3v3-52a2199edaa520408308a5e59b61040c.png";